export const version = '2.20.3';
//# sourceMappingURL=version.js.map